import React, { useState, useEffect } from 'react';
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminBill(props) {
    const [bill_param, setBill_param] = useState({
        unitrate_grid_export: '',
        edittime: '',
    });

    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    useEffect(() => {
        api_load()
        return () => {

        }
    }, []);


    async function api_load() {
        setmodal_load({ enable: true, message: "Sending app update command to center server." })
        await sleep(500)

        const formData = new FormData()

        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/billsystem/getdata", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    if (response.data.bill !== undefined) {
                        setBill_param(response.data.bill)
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }

    async function api_save() {
        setmodal_load({ enable: true, message: "Editing bill parameter in a database." })
        await sleep(500)

        const formData = new FormData()
        formData.append('unitrate_grid_export', bill_param.unitrate_grid_export)
        axios.post(process.env.REACT_APP_API_URL + "/proxy/center/api/reference/billsystem/edit", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your bill parameter has been edited.",
                        enable: true
                    });
                    if (response.data.bill !== undefined) {
                        setBill_param(response.data.bill)
                    }
                }
                else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    });
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                });
            });
    }


    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-th-large"></i> Bill parameter</h4>
                                    <p className="mb-0">Manage all billing common parameter</p>
                                </div>
                            </div>
                            <hr className="new-section-xs mb-2" />
                            <div className="d-block mt-2" style={{ width: "160px" }}>
                                <div className="form-group">
                                    <label htmlFor="unitrate_grid_export">Unit Rate Grid Export</label>
                                    <input type="text" className="form-control" name="billing_address" value={bill_param.unitrate_grid_export} onChange={(e) => {
                                        setBill_param({
                                            ...bill_param,
                                            unitrate_grid_export: e.target.value
                                        })
                                    }} required />
                                </div>
                                <button className="btn btn-warning btn-sm fw-600 mt-2" onClick={() => { api_save() }}>Save Bill Param</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminBill